<template>

    <div class="chart-dog-step-2">

        <b-tabs v-model="currentSeriesTab">
            <b-tab v-for="(series, seriesIndex) in docData.chart.chartSeries"
                   v-model="docData.currentSeries">
                <template v-slot:title>
                    {{ series.title ? series.title : 'Series ' + (seriesIndex + 1) }}
                </template>
                <!-- TODO: active tab (docData.currentSeries) -->

                <b-card no-body class="mb-3"
                        v-for="(phase, phaseIndex) in docData.chart.phases">
                    <b-card-header>
                        <div class="float-right">
                            <b-btn variant="default"
                                   @click="showPhaseEditModal(phase)">
                                <open-icon name="pencil"></open-icon>
                            </b-btn>
                            <b-btn variant="default"
                                   @click="deletePhase(phase)">
                                <open-icon name="delete"></open-icon>
                            </b-btn>
                        </div>

                        {{ phase.title }}
                        <chart-dog-legend-label :series-shape="currentChartSeriesMarkerName"
                                                :series-color-code="currentChartSeriesColorCode"
                                                :phase-index="+phase.index">
                        </chart-dog-legend-label>

                        &nbsp;<span class="phase-dates">
                            {{ phase.start | moment('MM/D/YY') }} - {{ phase.end | moment('MM/D/YY') }}
                        </span>

                    </b-card-header>
                    <b-card-body>
                        <div v-for="dp in listDataPointsForSeriesAndPhase(docData.currentSeries, phase.index)">
                            <b-form-input type="date" class="point-date mr-3"
                                          v-model="dp.date"
                                          @change="dataPointDateChanged(dp)"/>
                            <b-form-input type="number" class="point-value mr-3"
                                          placeholder="Value"
                                          v-model="dp.value"/>
                            <b-btn variant="danger"
                                   @click="deleteDataPoint(dp)">
                                <open-icon name="delete"></open-icon>
                            </b-btn>

                            <b-alert variant="danger" :show="hasDuplicateDate(dp)">
                                Duplicate data point for this date!
                            </b-alert>
                        </div>
                        <b-btn variant="success" class="float-right add-point"
                               @click="addDataPoint(phase.index)">
                            Add a Data Point
                        </b-btn>
                    </b-card-body>
                </b-card>

            </b-tab>
        </b-tabs>

        <b-btn variant="primary" size="lg" class="fixed-action-button"
               @click="addPhase()">
            <open-icon name="plus"></open-icon>
            Add A Phase
        </b-btn>

        <!-- edit phase modal -->

        <b-modal id="edit-phase-modal"
                 ok-only
                 title="Edit Phase Details">

            <b-form>
                <b-form-group label="Title">
                    <b-form-input v-model="editingPhase.title"></b-form-input>
                </b-form-group>
                <b-form-group label="Start Date">
                    <b-form-input type="date"
                                  v-model="editingPhase.start"></b-form-input>
                </b-form-group>
                <b-form-group label="End Date">
                    <b-form-input type="date"
                                  v-model="editingPhase.end"></b-form-input>
                </b-form-group>
            </b-form>

        </b-modal>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ChartDogMixin from "@/providers/ChartDogMixin"

    export default Vue.extend({
        name: "ChartDogStep2",
        mixins: [ToolMixin, ChartDogMixin],
    })

</script>


